module.exports = __webpack_public_path__ + "img/trello.aead7285.png";